import { AddressResponse } from "store/addresses/types";
import { EscrowsBodyAddressDetailsType } from "store/escrow/escrows-table/types";
import { InitialValues as AddressInitialValues } from "components/modal/components/addresses-side-modal/hooks/types";

export const getAddress = (address: AddressResponse | EscrowsBodyAddressDetailsType | AddressInitialValues) => {
  return `${address.street}, ${address.buildingNumber}${address.apartments ? `/${address.apartments}` : ``}, ${
    address.city
  }, ${address.state ? `${address.state},` : ``} ${address.country}, ${address.postCode}`;
};
